// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MiMx","col":"styles_col__JKyLC"};